import { compose } from 'lodash/fp'
import stripTags from './stripTags'
import trim from './trim'

export { trim, stripTags }

export default compose(
  trim,
  stripTags,
)
